"use client";

import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

/** Light or dark, as an icon alongside the account icons. */
export function EditorialThemeToggle() {
	const { resolvedTheme, setTheme } = useTheme();
	const [mounted, setMounted] = useState(false);
	useEffect(() => setMounted(true), []);

	const isDark = mounted && resolvedTheme === "dark";
	const label = isDark ? "Switch to light mode" : "Switch to dark mode";
	const Icon = isDark ? Sun : Moon;

	return (
		<button
			type="button"
			className="ed-account-nav__icon ed-button-text"
			onClick={() => setTheme(isDark ? "light" : "dark")}
			aria-label={label}
			title={label}
		>
			<Icon aria-hidden="true" strokeWidth={1.6} />
		</button>
	);
}
